import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export const usecandidateSidebarStore = create()(
  devtools(
    persist(
      (set) => ({
        menuItem: [],
        menuItemValue: 0,
        updateMenuItem: (data) => set({ menuItem: data }),
        updatemenuItemValue:value=>set({menuItemValue:value})
      }),
      { name: 'candidateSidebarStore' }
    )
  )
);
